import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ConnectMapService from '../../core/service'

//search company
export const getSearchCompany = createAsyncThunk(
  'connectMap/interconnectionMap/getSearchCompany',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ConnectMapService.getSearchCompany(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//search person
export const getSearchPerson = createAsyncThunk(
  'connectMap/interconnectionMap/getSearchPerson',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ConnectMapService.getSearchPerson(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const getSearchCompanyForPersonFilter = createAsyncThunk(
  'connectMap/interconnectionMap/getSearchCompanyForPersonFilter',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ConnectMapService.getSearchCompany(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const createConnectionMapLogs = createAsyncThunk(
  'connectMap/interconnectionMap/createConnectionMapLogs',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ConnectMapService.createConnectionMapLogs(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const updateConnectionMapLogs = createAsyncThunk(
  'connectMap/interconnectionMap/updateConnectionMapLogs',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ConnectMapService.updateConnectionMapLogs(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
